import * as React from 'react';
import { HiddenInput, Modal, ModalBody, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton, AlertMessage, AlertType, Form } from "soprasteria-ui-library";
import { IReferralResponseModel } from '../../../../../models/IReferral';
import { useAuth } from '../../../../../App';
import { ReferralResponseApi } from '../../../../../api/ReferralResponseApi';
import { setMessage } from '../../../../../helpers/MessageHelper';

interface IReferralApproveModal {
    referralId: number;
    onSuccess: (message: string) => void
}

export const ReferralApproveModal: React.FunctionComponent<IReferralApproveModal> = ({ referralId, onSuccess }) => {

    const api = new ReferralResponseApi(useAuth());
    const [errorMessage, setErrorMessage] = React.useState<string>();
    const [isApiPending, setIsApiPending] = React.useState<boolean>(false);

    const approveReferral = (data: IReferralResponseModel) => {
        setIsApiPending(true);
        api.approveReferral(data.referralId.toString(), () => {
            document.getElementById("close-referral-approve-modal")?.click();
            onSuccess("Specialistremissen har godkänts");
        }, (error) => {
            const newMessage = setMessage(error, errorMessage ?? "");
            setErrorMessage(newMessage);
        }, () => setIsApiPending(false))
    }

    return (
        <Modal header="Godkänn specialistremiss" modalSize={ModalSize.small} id="referral-approve-modal">
            <Form onSubmit={approveReferral}>
                <ModalBody>
                    <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                    <HiddenInput name="referralId" value={referralId.toString()} />
                    <p>Är du säker på att du vill godkänna specialistremissen?</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton id="close-referral-approve-modal" buttonType={ButtonType.general} buttonText="Stäng" data-dismiss="modal" />
                    <CustomSubmitButton isLoading={isApiPending}>Godkänn</CustomSubmitButton>
                </ModalFooter>
            </Form>
        </Modal>
    )
}